import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorAlert = _resolveComponent("ErrorAlert")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_AppContainer = _resolveComponent("AppContainer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ErrorAlert),
    _createVNode(_component_AppContainer, { class: "h-100 w-100" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_card, { class: "text-center login" }, {
          header: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("h2", {
              class: "logo",
              justify: "center"
            }, "eP2AS License", -1)
          ])),
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}